import { createFileRoute } from "@tanstack/react-router";
import { BlockRenderer } from "~/components/blocks";
import { loadStandalonePage } from "~/utils/content-fns";
import {
  heroHeading,
  pageSchemaScripts,
  seo,
  seoLinks,
  type PageSchemaFields,
  type PageSchemaType,
} from "~/utils/seo";

export const Route = createFileRoute("/platform-overview")({
  loader: async () => {
    const page = await loadStandalonePage({
      data: { path: "platform-overview.md" },
    });
    return {
      title: (page.title as string) || "C1 Platform",
      seo_title: page.seo_title as string | undefined,
      seo_description: page.seo_description as string | undefined,
      schema_type: page.schema_type as PageSchemaType | undefined,
      schema: page.schema as PageSchemaFields | undefined,
      blocks: (page.blocks as any[]) || [],
    };
  },
  head: ({ loaderData }) => ({
    meta: seo({
      title: loaderData?.seo_title || loaderData?.title,
      description: loaderData?.seo_description || "",
      url: "/platform-overview",
    }),
    links: seoLinks({ url: "/platform-overview" }),
    scripts: pageSchemaScripts({
      schemaType: loaderData?.schema_type,
      url: "/platform-overview",
      name: heroHeading(loaderData?.blocks),
      title: loaderData?.seo_title || loaderData?.title || "C1 Platform",
      description: loaderData?.seo_description,
      productName: loaderData?.title,
      fields: loaderData?.schema,
    }),
  }),
  component: PlatformOverviewPage,
});

function PlatformOverviewPage() {
  const page = Route.useLoaderData();
  return <BlockRenderer blocks={page.blocks} />;
}
